import * as ngCore from '@angular/core'

import * as state from '../../../../../../../../../../../state'
import * as widget from '../../../../../../widget'

/**
 * Renders the referenced widget within a page
 */
@ngCore.Component({
  imports: [widget.Component],
  selector: 'atn-mosaic-grid-widget',
  standalone: true,
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.mosaic.endUser.currentRendering.Feature } */
  public readonly currentRendering = ngCore.inject(
    state.mosaic.endUser.currentRendering.Feature,
  )
  /**
   * @see {@link state.mosaic.models.widget.Ref}
   */
  public readonly refSg = ngCore.input.required<state.mosaic.models.widget.Ref>(
    {
      alias: 'ref',
    },
  )
}
